import * as Redux from 'redux'
import * as IsActive from '../../components/is_active'
import * as Modal from '../../components/modal'
import * as Sortable from '../../components/sortable'
import * as Request from '../../request'
import * as Router from '../../router'
import * as Constants from './constants'
import * as Types from './types'

const initialState: Types.ComponentState = {
  filter: null,
}

type Action = Request.SuccessAction & Sortable.SortAction & IsActive.StateChangeActionObject

const dataReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case Router.ON_ENTER:
    case Request.requestConstant(Constants.FETCH_FILTER_GROUP):
      return {
        ...state,
      }
    case Request.errorConstant(Constants.FETCH_FILTER_GROUP):
      return {
        ...state,
        filter: null,
      }
    case Request.successConstant(Constants.FETCH_FILTER_GROUP):
      return {
        filter: action.payload.response,
      }
    case Sortable.sortTableConstant(Constants.FETCH_FILTER_GROUP):
      return {
        ...state,
        filter: {
          ...state.filter,
          tags: Sortable.sortState(state.filter.tags, action.options.value),
        },
      }
    case IsActive.updateStatusConstant(Constants.UPDATE_FILTER_GROUP_TAG):
      const copy = {
        ...state,
      }
      copy.filter.tags.filter((t) => t.id === action.change.id)[0].is_active = action.change.new_value
      return copy
    default:
      return state
  }
}

const modalReducerEvent: Modal.ReducerEvent<Types.ModalData> = {
  initializeState: () => ({tags: ''}),
  requestEvent: Constants.ADD_FILTER_GROUP_TAG,
}

const sortTagReducerEvent: Sortable.ReducerEvent<Types.FilterGroupTag> = {
  defaultSort: {field: 'tag', dir: 'desc'},
  requestEvent: Constants.FETCH_FILTER_GROUP,
}

export const reducer = Redux.combineReducers({
  data: dataReducer,
  modal: Modal.reducer(modalReducerEvent),
  view: Sortable.viewReducer(sortTagReducerEvent),
})

const groupsReducerEvent: Sortable.ReducerEvent<Types.FilterGroup> = {
  defaultSort: {field: 'name', dir: 'asc'},
  requestEvent: Constants.FETCH_FILTER_GROUPS,
}

export const filterGroupsReducer = Redux.combineReducers({
  data: Sortable.stateReducer(groupsReducerEvent),
})



// WEBPACK FOOTER //
// ./src/pages/filter-group/reducer.ts